<template>
    <b-row>
        <b-col cols="12" v-for="def in fieldDefs.modules" :key="def.key">
            <div class="accordion" role="tablist">
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="`${def.key}-accordion`" variant="dark">{{ $t(def.title) }}</b-button>
                </b-card-header>
                <b-collapse :id="`${def.key}-accordion`" :visible="def.key == 'input'" accordion="my-accordion" role="tabpanel">
                    <draggable 
                        tag="div" 
                        class="row m-1" 
                        :list="def.fields"
                        :clone="onClone"
                        :group="group"
                        @start="dragStart"
                        @end="dragEnd"
                        @change="change"
                        ghost-class="ghost"
                    >
                        <b-col cols="12" md="6" class="mt-3" v-for="defField in def.fields" :key="defField.key" align-self="start">
                            <b-badge class="fieldBadge" v-if="field == null">
                                <b-row>
                                <b-col cols="2"> <b-icon :icon="defField.icon" /></b-col>
                                <b-col cols="9" align-self="center">  {{ $t(defField.title) }} </b-col>
                                </b-row>
                            </b-badge>

                            <template v-else-if="field !== null && (field.module == defField.field.module && field.type == defField.field.type)">
                                <b-row>
                                    <b-col cols="12">
                                        <b-skeleton width="100%" height="25px" animation="throb" />
                                    </b-col>
                                </b-row>
                            </template>

                            <b-badge class="fieldBadge" v-else>
                                <b-row>
                                <b-col cols="2"> <b-icon :icon="defField.icon" /></b-col>
                                <b-col cols="9" align-self="center">  {{ $t(defField.title) }} </b-col>
                                </b-row>
                            </b-badge>

                        </b-col>
                    </draggable>
                </b-collapse>
            </b-card>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import fieldDefs from "@/components/identityFields/defsv2"
import fieldObj from "@/components/identityFields/field"
import draggable from 'vuedraggable'
import IdentityFields from '@/components/identityFields/IdentityFields'

export default {
    name: 'DraggableFields',
    components: {
        draggable,
        IdentityFields
    },
    props: {
        group: {
            type: Object
        },

        mutateClone: {
            type: Function,
            default: (o) => o
        }
    },
    data: function() {
        return {
            draggingStarted: false,
            draggedElement: null
        }
    },

    methods: {
        onClone(original) {
            let fieldO = _.cloneDeep(fieldObj)

            const d = {
                ...fieldO,
                ...original.field,
            }

            return this.mutateClone(d)
        },

        dragStart(e) {
            this.draggingStarted = true
            this.draggedElement = e.item._underlying_vm_

            this.$emit('dragStart', e)
        },

        dragEnd(e) {
            this.draggingStarted = false
            this.draggedElement = null

            console.log("dragEnd", e)

            this.$emit('dragEnd', e)
        },

        change(e) {
            console.log("change", e)
        }
    },

    computed: {
        fieldDefs() {
            return fieldDefs
        },

        content: {
            get() {
                return this.value
            },

            set(val) {
                this.$emit('input', val)
            }
        },

        field() {
            return this.draggedElement
        }
    }
}
</script>